import axios from "axios";

import { authTokenRequestInterceptor } from "./interceptors";

export const getBaseAxiosInstance = (baseURL: string) => {
  const api = axios.create({ baseURL });

  api.interceptors.request.use(authTokenRequestInterceptor);

  return api;
};
